"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var theme = {
  colors: {
    disabledColor: 'rgba(9, 30, 66, 0.04)',
    primaryColor: 'rgb(0, 82, 204)',
    primaryDarkColor: '#42526e',
    primaryLightColor: '#fff'
  }
};
exports.default = theme;